exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Topbar {\n  background-color: #000;\n  height: 50px;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  z-index: 2;\n  -ms-flex-pack: justify;\n  justify-content: space-between; }\n  .Topbar .BrandLink {\n    text-align: left; }\n  .Topbar .BrandLogo {\n    text-align: left; }\n    .Topbar .BrandLogo img {\n      height: 30px;\n      margin: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Topbar/Topbar.scss
// module id = 1603
// module chunks = 0